import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaGithub, FaEnvelope, FaInstagram, FaMapMarkerAlt, FaShieldAlt } from 'react-icons/fa';

const Footer = () => (
  <footer style={{
    backgroundColor: '#040d1a',
    borderTop: '1px solid rgba(69, 170, 242, 0.2)',
    color: '#94a3b8',
    padding: '48px 24px 24px 24px',
    marginTop: 'auto',
    fontSize: '0.95rem',
  }}>
    <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
      gap: '40px',
      marginBottom: '40px',
    }}>
      {/* Brand & Value Statement */}
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
          <img
            src="/AdedejiwebuseX21ms.png"
            alt="Adedeji Babalola Logo"
            style={{ height: '38px', borderRadius: '6px' }}
          />
          <h3 style={{ color: '#ffffff', margin: 0, fontSize: '1.2rem' }}>Adedeji Babalola</h3>
        </div>
        <p style={{ fontSize: '0.9rem', lineHeight: '1.6', color: '#94a3b8' }}>
          Software Engineer, Cloud Infrastructure Architect (AWS/Azure), Data Analyst &amp; Cisco-Certified Network Specialist. Open for full-time career roles and contract technical consulting.
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#45aaf2', fontSize: '0.88rem' }}>
          <FaMapMarkerAlt /> Finland (Open to Relocation &amp; Remote)
        </div>
      </div>

      {/* Navigation & Career Links */}
      <div>
        <h4 style={{ color: '#ffffff', fontSize: '1.05rem', marginBottom: '16px', borderBottom: '2px solid #45aaf2', paddingBottom: '6px', display: 'inline-block' }}>
          📌 Navigation &amp; Resume
        </h4>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <li><Link to="/cv" style={{ color: '#cbd5e1', textDecoration: 'none' }}>→ Resume / CV</Link></li>
          <li><Link to="/skills" style={{ color: '#cbd5e1', textDecoration: 'none' }}>→ Technical Skills</Link></li>
          <li><Link to="/about" style={{ color: '#cbd5e1', textDecoration: 'none' }}>→ About Adedeji</Link></li>
          <li><Link to="/projects" style={{ color: '#cbd5e1', textDecoration: 'none' }}>→ Project Portfolio</Link></li>
          <li><Link to="/tools" style={{ color: '#cbd5e1', textDecoration: 'none' }}>→ Tools</Link></li>
          <li><a href="/skills_deck.html" target="_blank" rel="noopener noreferrer" style={{ color: '#cbd5e1', textDecoration: 'none' }}>→ Download Presentation Deck</a></li>
        </ul>
      </div>

      {/* For Contract Clients & Businesses */}
      <div>
        <h4 style={{ color: '#ffffff', fontSize: '1.05rem', marginBottom: '16px', borderBottom: '2px solid #00d2d3', paddingBottom: '6px', display: 'inline-block' }}>
          💼 For Contract &amp; Consulting
        </h4>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <li><Link to="/services" style={{ color: '#cbd5e1', textDecoration: 'none' }}>→ Cloud &amp; Web Development Contracts</Link></li>
          <li><Link to="/services" style={{ color: '#cbd5e1', textDecoration: 'none' }}>→ Network Security &amp; Setup Consulting</Link></li>
          <li><Link to="/services" style={{ color: '#cbd5e1', textDecoration: 'none' }}>→ Data Analytics &amp; Dashboard Builds</Link></li>
          <li><Link to="/contact" style={{ color: '#cbd5e1', textDecoration: 'none' }}>→ Request a Project Quote</Link></li>
        </ul>
      </div>

      {/* Social & Direct Contact */}
      <div>
        <h4 style={{ color: '#ffffff', fontSize: '1.05rem', marginBottom: '16px', borderBottom: '2px solid #f8d210', paddingBottom: '6px', display: 'inline-block' }}>
          🌐 Connect &amp; Socials
        </h4>
        <p style={{ fontSize: '0.88rem', color: '#94a3b8', marginBottom: '16px' }}>
          Direct Email: <a href="mailto:daygme@gmail.com" style={{ color: '#45aaf2', textDecoration: 'none' }}>daygme@gmail.com</a>
        </p>
        <div style={{ display: 'flex', gap: '16px' }}>
          <a href="https://linkedin.com/in/adedeji-babalola-9a71aa30" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" style={{ color: '#ffffff', fontSize: '1.4rem' }}>
            <FaLinkedin />
          </a>
          <a href="https://github.com/dejoo10" target="_blank" rel="noopener noreferrer" aria-label="GitHub" style={{ color: '#ffffff', fontSize: '1.4rem' }}>
            <FaGithub />
          </a>
          <a href="mailto:daygme@gmail.com" aria-label="Email" style={{ color: '#ffffff', fontSize: '1.4rem' }}>
            <FaEnvelope />
          </a>
          <a href="https://www.instagram.com/idaygme/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" style={{ color: '#ffffff', fontSize: '1.4rem' }}>
            <FaInstagram />
          </a>
        </div>
      </div>
    </div>

    {/* Bottom Copyright */}
    <div style={{
      borderTop: '1px solid rgba(255,255,255,0.08)',
      paddingTop: '20px',
      textAlign: 'center',
      fontSize: '0.85rem',
      color: '#64748b',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '12px',
      maxWidth: '1200px',
      margin: '0 auto',
    }}>
      <div>© 2025-2026 Adedeji Babalola. All rights reserved.</div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <FaShieldAlt style={{ color: '#2ecc71' }} /> Built with React, AWS Architecture &amp; Network Hardening Best Practices
      </div>
    </div>
  </footer>
);

export default Footer;
